import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import InputField from "../../components/form/InputField";
import { getDate, getTodayDate } from "../../util";
import NumberInputField from "../../components/form/NumberInputField";
import TextAreaField from "../../components/form/TextAreaField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import SelectField from "../../components/form/SelectField";

const CurrencySettings = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      e.preventDefault();
    } catch (error) {}
  };
  return (
    <MainContainer className="bg-content border border-bkg2">
      <h3 className="p-3">Currency Settings</h3>
      <form
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col sm:px-10 "
      >
        <div className="flex gap-6">
          <SelectField
            register={register}
            name="base_currency"
            label="Base Currency"
            errors={errors.base_currency}
            data={[
              { id: "", name: "-- Select Currency" },
              { id: "", name: "US Dollar $" },
              { id: "", name: "Euro &" },
            ]}
          />
          <SelectField
            register={register}
            name="target_currency"
            label="Target Currency"
            errors={errors.target_currency}
            data={[
              { id: "", name: "-- Select Currency" },
              { id: "", name: "US Dollar $" },
              { id: "", name: "Euro &" },
            ]}
          />
        </div>
        <div className="p-5 text-center">Approval Status</div>
        <InputField
          register={register}
          name="year"
          label="Year"
          errors={errors.year}
          type="text"
        />
        <InputField
          register={register}
          name="daily_update"
          label="Daily Update"
          errors={errors.daily_update}
          type="checkbox"
        />
        <ResourseButtons link to="/accounts/maintenance" />
      </form>
    </MainContainer>
  );
};

export default CurrencySettings;
